  <div *ngIf="showModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div [ngClass]='{"modal-lg modal-dialog-scrollable": modalType === eventModalType.VIEW_ALL}' class="custom-theme-modal modal-dialog modal-md modal-dialog-centered"
      role="document">
      <div class="modal-content">
        <div class="modal-header d-block pt-4" *ngIf="title !=='subscribe'">
          <div class="row">
            <div class="col-6 pr-0">
              <p class="heading-4">
                 <span class="color-grey-700">{{title}}</span>
              </p>
            </div>
            <div class="col-6 text-right cursor-pointer" (click)="onHidden()">
              <img src="assets/themes/icons/cancel.svg" alt="cross">
            </div>
          </div>
        </div>
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>